import { createAction } from 'redux-actions';

import { SET_CLIENT_RETURN_URL } from 'app/features/checkout/actionTypes';
import { getParsedReturnUrl } from 'app/router/selectors';
import crunchyrollDomains from 'app/router/constants/crunchyrollDomains';

const setClientReturn = createAction(SET_CLIENT_RETURN_URL);

function setClientReturnUrl() {
  return (dispatch, getState) => {
    const parsedReturnUrl = getParsedReturnUrl(getState());
    const url = document.createElement('a');

    url.href = parsedReturnUrl;

    if (
      !url.username &&
      url.hostname &&
      crunchyrollDomains.includes(url.hostname)
    ) {
      dispatch(setClientReturn(parsedReturnUrl));
    }
  };
}

export { setClientReturnUrl };
